export type GameName = "foldaway" | "spillover" | "lockstep" | "burnout" | "echo";

export const ALL_GAMES: GameName[] = ["foldaway", "spillover", "lockstep", "burnout", "echo"];

export type DifficultyLevel = "easy" | "medium" | "hard" | "expert";
export const ALL_DIFFICULTIES: DifficultyLevel[] = ["easy", "medium", "hard", "expert"];
export const DEFAULT_DIFFICULTY: DifficultyLevel = "medium";

export interface User {
  id: number;
  email: string;
  display_name: string;
  avatar_url: string | null;
  created_at: string;
}

export interface Completion {
  id: number;
  user_id: number;
  game: GameName;
  puzzle_date: string;
  stars: number;
  metric: number;
  time_ms: number;
}

export interface DailySummary {
  id: number;
  user_id: number;
  puzzle_date: string;
  total_stars: number;
  games_done: number;
  all_five: boolean;
}

export interface LeaderboardEntry {
  rank: number;
  display_name: string;
  avatar_url: string | null;
  stars: number;
  metric: number;
  time_ms: number;
}

export interface DailyFiveEntry {
  rank: number;
  display_name: string;
  avatar_url: string | null;
  total_stars: number;
  games_done: number;
}

export interface PlayerStats {
  totalPlayed: number;
  totalStars: number;
  streak: number;
  maxStreak: number;
  gameBreakdown: Record<GameName, { played: number; stars: number }>;
}

export interface JwtPayload {
  sub: number;
  exp: number;
}
